(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mp-language-selector"] && !Shopify.designMode) return;
  try {
    const mpLanguageForm=document.getElementById('MpLanguageForm');
if(mpLanguageForm){
 const select=mpLanguageForm.querySelector('select');
 const remember=()=>{try{localStorage.setItem('mp-language-choice',select.value)}catch(e){}};
 mpLanguageForm.addEventListener('submit',remember);
 select.addEventListener('change',()=>{remember();mpLanguageForm.requestSubmit()});
 const url=new URL(location.href);
 let stored;try{stored=localStorage.getItem('mp-language-choice')}catch(e){}
 const preferred=(navigator.languages?.[0]||navigator.language||'fr').split('-')[0];
 if(!stored && location.pathname==='/' && !url.searchParams.has('preview_theme_id') && !document.documentElement.hasAttribute('data-shopify-design-mode')){
   const target=preferred==='en'?'en':'fr';
   if(Array.from(select.options).some(option=>option.value===target)){
     try{localStorage.setItem('mp-language-choice',target)}catch(e){}
     if(select.value!==target){select.value=target;mpLanguageForm.requestSubmit()}
   }
 }
}
  } catch(e) { console.error(e); }
})();

})();
